import React from 'react';
import MaterialIcon from '../ui/MaterialIcon';

function StrategyOptimizedCard({ strategy, onViewDetails }) {
  if (!strategy) return null;

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary via-primary to-primary-dark p-5">
      {/* Decorative circles */}
      <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full bg-white/[0.04]" />
      <div className="absolute -bottom-4 -left-4 w-16 h-16 rounded-full bg-white/[0.04]" />

      {/* Badge */}
      <div className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm rounded-full px-3 py-1 mb-3">
        <MaterialIcon name="auto_awesome" size={14} className="text-white" />
        <span className="text-xs font-semibold text-white">Strategy Optimized</span>
      </div>

      {/* Card Recommendation */}
      <div className="flex items-start gap-3 mb-3">
        <div className="w-12 h-12 rounded-xl bg-white/15 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
          <MaterialIcon name="credit_card" size={24} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white font-bold text-base leading-tight">
            {strategy.cardName}
          </p>
          <p className="text-white/70 text-xs mt-0.5">
            {strategy.cardNetwork} &middot; {strategy.pointsMultiplier} points on travel
          </p>
        </div>
      </div>

      {/* Savings */}
      <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 mb-3">
        <div className="flex items-baseline gap-2">
          <span className="text-white/60 text-xs">Estimated savings</span>
          <span className="text-white font-bold text-xl">${strategy.estimatedSavings}</span>
        </div>
      </div>

      {/* Explanation */}
      <p className="text-white/80 text-xs leading-relaxed">
        {strategy.explanation}
      </p>

      {/* Action */}
      {onViewDetails && (
        <button
          onClick={onViewDetails}
          className="mt-3 w-full flex items-center justify-center gap-1.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm rounded-xl py-2.5 text-white text-sm font-semibold transition-colors"
        >
          View Full Strategy
          <MaterialIcon name="arrow_forward" size={16} className="text-white" />
        </button>
      )}
    </div>
  );
}

export default StrategyOptimizedCard;
